import { LOCALE_NAMES, OFFERED_LOCALES, type Locale } from '@shared/i18n';
import { useI18n } from '../lib/i18n';

/**
 * Read this page in another language.
 *
 * It renders nothing when only one language is offered — a choice of one
 * is noise — and it is only placed on screens whose strings are
 * translated, so choosing Español never leads to an English page. The
 * business's own words (its name, services and policies) stay as the
 * business wrote them, which is why the control says "Language" rather
 * than promising a translation of everything on screen.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, t, choose } = useI18n();
  if (OFFERED_LOCALES.length < 2) return null;
  return (
    <div className={`language-switcher${className ? ` ${className}` : ''}`}>
      <label className="language-switcher__label" htmlFor="language-choice">
        <GlobeGlyph />
        <span>{t('language.choose')}</span>
      </label>
      <select
        id="language-choice"
        className="language-switcher__select"
        value={locale}
        onChange={(e) => choose(e.target.value as Locale)}
      >
        {OFFERED_LOCALES.map((option) => (
          <option key={option} value={option}>{LOCALE_NAMES[option]}</option>
        ))}
      </select>
    </div>
  );
}

function GlobeGlyph() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
    </svg>
  );
}
